import './smslogdetails.css';
import Skeleton from '@mui/material/Skeleton';

const Loading = ({data, loading}) => {
    if (loading) {
        return <div className="px-2" style={{float: 'left'}}><Skeleton variant="rectangular" height={20} width={50} /></div>;
    } else {
        return <div className="px-2" style={{float: 'left'}}>{data}</div>;
    }
}

const SmsLogDetails = ({data, loading}) => {
    const smsLogData = data;
    if (smsLogData == undefined) {
        return <div>No data</div>;
    }
    let status = ''
    if (loading) {
        status = '';
    } else {
        status = 'status-ok';
    }
    
    // Check if DLR status indicates an error
    const hasError = smsLogData.dlr_status && (smsLogData.dlr_status === 'UNDELIV' || smsLogData.dlr_status === 'ERROR');
    const hasWarning = !smsLogData.smsc_response;
    const errorClass = hasError ? 'dlr-error' : '';
    const warningClass = hasWarning ? 'dlr-warning' : '';
    
    return (
        <div className={`cdrcard shadow-sm ${errorClass} ${warningClass}`}>
            <div className="card-body">
                <div className="sub-header d-flex">SMS Detail <Loading data={smsLogData.ATRMESSAGEID} loading={loading} /></div>
                <div className={`content mt-3 ${status}`}>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table-bordered w-100">
                                <tbody>
                                    <tr>
                                        <td><strong>Date:</strong> <Loading data={smsLogData.ATRTIMESTAMP} loading={loading} /> GMT</td>
                                        <td><strong>Time Zone: </strong> GMT</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Message Type:</strong> <Loading data={smsLogData.ATRMSGTYPE} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Message Direction:</strong> <Loading data={smsLogData.ATRDIRECTION == 'out' ? 'MT' : 'MO'} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Destination Address:</strong> <Loading data={smsLogData.ATRDESTADDR} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Source Address:</strong> <Loading data={smsLogData.ATRSRCADDR} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>DLR:</strong> <Loading data={smsLogData.ATRREGDELIVERY	} loading={loading} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <table className="table-bordered w-100">
                                <tbody>
                                    <tr>
                                        <td colSpan={2}><strong>Message:</strong> <Loading data={smsLogData.sms_data?.ATRTEXT} loading={loading} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <table className="table-bordered w-100">
                                <tbody>
                                    <tr>
                                        <td colSpan={2}><strong>SRC ADDR NPI:</strong> <Loading data={smsLogData.ATRSRCADDRNPI	} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>SRC ADDR TON:</strong> <Loading data={smsLogData.ATRSRCADDRTON	} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>DEST ADDR NPI:</strong> <Loading data={smsLogData.ATRDESTADDRNPI	} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>DEST ADDR TON:</strong> <Loading data={smsLogData.ATRDESTADDRTON} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>VALIDITY:</strong> <Loading data={smsLogData.ATRVALIDITYPERIOD	} loading={loading} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {smsLogData.smsc_response && (
                        <div className="row mt-4">
                            <div className="col-md-12">
                                <table className="table-bordered w-100">
                                    <tbody>
                                        <tr>
                                            <td colSpan={2}><strong>SMSC Status:</strong> <Loading data={smsLogData.smsc_response?.command_status} loading={loading} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <table className="table-bordered w-100">
                                <tbody>
                                    {(smsLogData.originating_carrier?.ATRNAME || smsLogData.client?.ATRACCTNAME) && (
                                        <tr>
                                            <td colSpan={2}>
                                                <strong>{smsLogData.originating_carrier?.ATRNAME ? 'Originating Carrier' : 'Client'}:</strong> 
                                                <Loading 
                                                    data={
                                                        smsLogData.originating_carrier?.ATRNAME 
                                                            ? smsLogData.originating_carrier.ATRNAME 
                                                            : `${smsLogData.client?.ATRCLIENTIDNUMBER || ''}${smsLogData.client?.ATRACCTNAME ? ` (${smsLogData.client.ATRACCTNAME})` : ''}`
                                                    }
                                                    loading={loading} 
                                                />
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td colSpan={2}><strong>Sell Amount:</strong> <Loading data={smsLogData.ATRCLIENTAMOUNT !== undefined && smsLogData.ATRCLIENTAMOUNT !== null ? Number(smsLogData.ATRCLIENTAMOUNT).toFixed(4) : ''} loading={loading} /><Loading data={smsLogData.sell_currency?.ATRCURNAME} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Terminating Carrier:</strong> <Loading data={smsLogData.termination} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Cost Amount:</strong> <Loading data={smsLogData.buy_amount !== undefined && smsLogData.buy_amount !== null ? Number(smsLogData.buy_amount).toFixed(4) : ''} loading={loading} /><Loading data={smsLogData.buy_currency?.ATRCURNAME} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Profit:</strong> <Loading data={smsLogData.profit !== undefined && smsLogData.profit !== null ? Number(smsLogData.profit).toFixed(4) : ''} loading={loading} /><Loading data={smsLogData.profit_currency_name} loading={loading} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    
                    <div className="row mt-4">
                        <div className="col-md-12">
                            {smsLogData.dlrs && smsLogData.dlrs.map((dlr, index) => (
                            <table key={index} className="table-bordered w-100">
                                <tbody>     
                                    <tr>
                                        <td colSpan={2}><strong>DLR {index + 1}:</strong></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Timestamp</strong> <Loading data={dlr.ATRTIMESTAMP} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Status</strong> <Loading data={dlr.ATRMSGSTATUS} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}><strong>Error</strong> <Loading data={dlr.ATRERR} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td><strong>SUB</strong> <Loading data={dlr.ATRSUB} loading={loading} /></td>
                                        <td><strong>DLVRD</strong> <Loading data={dlr.ATRDLVRD} loading={loading} /></td>
                                    </tr>
                                    <tr>
                                        <td><strong>SUB DATE</strong> <Loading data={dlr.ATRSUBDATE} loading={loading} /></td>
                                        <td><strong>DONE DDATE</strong> <Loading data={dlr.ATRDONEDATE} loading={loading} /></td>
                                    </tr>
                                </tbody>
                            </table>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmsLogDetails;